shadow$provide[397] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying vec4 vColor;

vec4 getColor() {
  if (vColor.a <= 0.0) discard;
  return vColor;
}
`;

};